import * as constants from './constants';

import paramsApi from '@/api/params';
import appApi from '@/api/app';

import {$public} from '@/utils';

//终端参数-版本信息
const terminalVersionAction = (data) => {
    return {
        type: constants.TERMINAL_VERSION,
        data
    };
};

//获取终端版本信息
export const getTerminalVersion = (data) => {
    return (dispatch) => {
        paramsApi.getTerminalVersion(data)
            .then(res => {
                dispatch(terminalVersionAction(res || {}));
            })
    };
};

//召测终端版本信息
export const readTerminalVersion = (data) => {
    return (dispatch) => {
        paramsApi.readTerminalVersion(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};


//终端参数-重启终端
export const restartTerminal = (data) => {
    return (dispatch) => {
        paramsApi.restartTerminal(data)
            .then(res => {
                if(res && data.callBack) data.callBack(res);
            })
    };
};


//终端参数-设备连接状态信息
const terminalLinkStatus = (data) => {
    return {
        type: constants.TERMINAL_LINK_STATUS,
        data
    };
};

export const getTerminalLinkStatus = (data) => {
    return (dispatch) => {
        paramsApi.getTerminalLinkStatus(data)
            .then(res => {
                dispatch(terminalLinkStatus(res || {}));
            })
    };
};



//终端参数-端口信息
const terminalPortInfoAction = (data) => {
    return {
        type: constants.TERMINAL_PORT,
        data
    };
};

//获取终端 端口信息
export const getTerminalPortInfo = (data) => {
    return (dispatch) => {
        paramsApi.getTerminalPortInfo(data)
            .then(res => {
                dispatch(terminalPortInfoAction(res || {}));
            })
    };
};

//召测终端 端口信息
export const readTerminalPortInfo = (data) => {
    return (dispatch) => {
        paramsApi.readTerminalPortInfo(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};

//写入终端 端口信息
export const writeTerminalPortInfo = (data) => {
    return (dispatch) => {
        paramsApi.writeTerminalPortInfo(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};


//电表配置 获取电表数据
const meterData = (data) => {
    return {
        type: constants.METER_DATA,
        data
    };
};

export const getMeterData = (data) => {
    return (dispatch) => {
        paramsApi.getMeterData(data)
            .then(res => {
                dispatch(meterData(res));
            })
    };
};


//清除终端档案数据
export const clearTerminalFile = (data) => {
    return (dispatch) => {
        paramsApi.clearTerminalFile(data)
        .then(res => {
            if(res){
                $public.suc('操作成功');
                dispatch(getMeterData({deviceId: data.deviceId}));
            }
        })
    };
};

//下选中-档案
export const downCheckboxMeter = (data) => {
    return (dispatch) => {
        paramsApi.downCheckboxMeter(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};


//电表配置-召选中
export const readCheckboxMeter = (data) => {
    return (dispatch) => {
        paramsApi.readCheckboxMeter(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};


//电表-送电断电
export const meterBreakcontrol = (data, deviceId) => {
    return (dispatch) => {
        paramsApi.meterBreakcontrol(data)
        .then(res => {
            if(res){
                $public.suc('操作成功');
                //更新列表
                // dispatch(getMeterData({deviceId}));
            }
        })
    };
};



//任务配置 获取电表数据
const taskData = (data) => {
    return {
        type: constants.TASK_DATA,
        data
    };
};

export const getTaskData = (data) => {
    return (dispatch) => {
        paramsApi.getTaskData(data)
        .then(res => {
            dispatch(taskData(res));
        })
    };
};



//设备任务读取
export const readTaskData = (data) => {
    return (dispatch) => {
        paramsApi.readTaskData(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};


//设备任务状态读取
export const readTaskStatusData = (data) => {
    return (dispatch) => {
        paramsApi.readTaskStatusData(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};


//设备启用禁用操作
export const handleEnableDisable = (data) => {
    return (dispatch) => {
        paramsApi.handleEnableDisable(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};


//设备任务下发
export const handleTaskDown = (data) => {
    return (dispatch) => {
        paramsApi.handleTaskDown(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};

//再次下发指令
export const handleAgainTaskDown = (data) => {
    return (dispatch) => {
        paramsApi.handleAgainTaskDown(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};



export const writeTimeOptionToWangGuan = (data) => {
    return (dispatch) => {
        paramsApi.writeTimeToOption(data)
            .then(res => {
                if(res) $public.suc('操作成功');
            })
    };
};
//设备时段读取-召测
export const readTimeInfo = (data) => {
    return (dispatch) => {
        paramsApi.readTimeInfo(data)
        .then(res => {
            if(res) $public.suc('操作成功');
        })
    };
};

//时段定义数据显示
const timeData = (data) => {
    return {
        type: constants.TIME_DATA,
        data
    };
};
//获取流控命令列表
export const getCommandList = (data) => {
    return (dispatch) => {
        return paramsApi.getCommandList(data);  //返回promise
    };
};
//获取时段的信息
export const getDeviceTimeInfoList = (data) => {
    return (dispatch) => {
        paramsApi.getDeviceTimeInfoList(data)
            .then(res => {
                if(res){
                    res.forEach((v,i)=>{
                        const arr = []
                        let nowVlue =''
                        if(v.period){
                            v.period.forEach((v1,i1)=>{
                                if(nowVlue != v1.period){
                                    nowVlue = v1.period
                                    arr.push(v1)
                                }
                            })
                            arr.forEach((v2,i2)=>{
                                if(i2 != arr.length-1){
                                    v2.time = v2.time +"-"+arr[i2+1].time
                                }else{
                                    v2.time = v2.time +"-24:00"
                                }
                            })
                            v.period = arr
                        }

                    })
                    dispatch(timeData(res));
                }

            })
    };
};

//获取集中区下的设备列表
export const getDeviceByWangGuan = (data) => {
    return (dispatch) => {
        return new Promise(resolve => {
            appApi.getOrgDeviceTreeData(data)
                .then(res => {
                    dispatch(taskData(res));
                    resolve(res)
                })
        })
    }
};
export const addMeter = (data) => {
    return (dispatch) => {
        return appApi.addMeter(data);  //返回promise
    };
};


//获取字典数据  通讯协议与连接方式
const sucGetProtocolList = (data,dictCode) => {
    return {
        type: constants[dictCode],
        data
    };
};

// 获取通讯质量列表数据
export const getProtocolList = (dictCode) => {
    return (dispatch) => {
        appApi.getProtocolList(dictCode)
            .then(res => {
                if(res){
                    dispatch(sucGetProtocolList(res.content,dictCode));
                }
            })
    };
};


export const getProductList = () => {
    return (dispatch) => {
        appApi.getProductList()
            .then(res => {
                if(res){
                    dispatch(sucGetProtocolList(res,'productList'));
                }
            })
    };
};
export const getAssetCodeInfo = (data) => {
    return new Promise((resolve,reject) => {
        appApi.getAssetCodeInfo(data)
            .then(res => {
                if(res){
                    getDeviceNoAndlogical(res)
                    resolve(res)
                }else{
                    reject()
                }
            })
    })
};

const getDeviceNoAndlogical = (v)=>{
    v.logicalAddress = v.logicalAddress || ''
    v.deviceNo = v.deviceNo || ''
    if(!v.detail){
        return
    }
    v.detail.forEach(v1=>{
        if(v1.codeType == 1){
            v.logicalAddress = v1.deviceNo
        }else if(v1.codeType == 2){
            v.deviceNo = v1.deviceNo
        }
    })
}

export const delDeviceData = (data)=>{
    return (dispatch) => {
        return new Promise(resolve => {
            appApi.delMeter(data)
                .then(res => {
                    resolve(res);
                })
        });
    };
}
